import {
  CorporateFormFields,
  SFTPOptions,
} from 'src/components/enterprise/features/Corporate/components/Form/types/CorporateForm';

export const composeSftpEmails = (emails?: string[]): string =>
  emails ? emails.join(',') : '';

export function transformSFTPModelToUI(
  sftpNotificationEmails?: string[] | null,
  sftpEmployeesEnabled?: boolean,
  sftpExpenseCodesEnabled?: boolean
): {
  sftpNotificationEmailsString: string;
  sftpOptions: SFTPOptions;
} {
  return {
    sftpNotificationEmailsString: composeSftpEmails(sftpNotificationEmails),
    sftpOptions: {
      sftpEmployeesEnabled,
      sftpExpenseCodesEnabled,
    },
  };
}

type shouldEnableSFTPArgs = {
  sftpEmployeesEnabled: boolean;
  sftpExpenseCodesEnabled: boolean;
};

export function shouldEnableSFTP({
  sftpEmployeesEnabled,
  sftpExpenseCodesEnabled,
}: shouldEnableSFTPArgs): boolean {
  return sftpEmployeesEnabled || sftpExpenseCodesEnabled;
}

interface SFTPModel {
  sftpNotificationEmails: string[];
  fileEncryptionEnabled: boolean;
  sftpEmployeesEnabled: boolean;
  sftpExpenseCodesEnabled: boolean;
}

const extractSftpOptions = ({
  sftpEmployeesEnabled,
  sftpExpenseCodesEnabled,
}): Pick<SFTPModel, 'sftpEmployeesEnabled' | 'sftpExpenseCodesEnabled'> => ({
  sftpEmployeesEnabled: Boolean(sftpEmployeesEnabled),
  sftpExpenseCodesEnabled: Boolean(sftpExpenseCodesEnabled),
});

const extractEmails = (emailsString: string): string[] =>
  emailsString.split(',').map((email) => email.trim());

export const transformSFTPUIToModel = ({
  enableSFTP,
  sftpNotificationEmailsString,
  fileEncryptionEnabled,
  sftpOptions,
}: {
  enableSFTP: boolean;
  sftpNotificationEmailsString: string;
  fileEncryptionEnabled: boolean;
  sftpOptions: SFTPOptions;
}): SFTPModel => {
  return enableSFTP
    ? {
        sftpNotificationEmails: extractEmails(sftpNotificationEmailsString),
        fileEncryptionEnabled,
        ...extractSftpOptions(sftpOptions),
      }
    : {
        sftpNotificationEmails: [],
        fileEncryptionEnabled: false,
        sftpEmployeesEnabled: false,
        sftpExpenseCodesEnabled: false,
      };
};

export function cleanupFormSFTPFields(
  formValues: Partial<CorporateFormFields>
): Partial<CorporateFormFields> {
  const { sftpNotificationEmailsString, sftpOptions, ...rest } = formValues;
  return rest;
}

export function validateSftpOptionSelection(
  values: Record<string, boolean>
): boolean | string {
  return (
    Object.values(values).some(Boolean) || 'Selecting an option is required'
  );
}

type SFTPOption = { id: string; label: string };
export const sftpOptions: SFTPOption[] = [
  {
    id: 'sftpEmployeesEnabled',
    label: 'Employees',
  },
  {
    id: 'sftpExpenseCodesEnabled',
    label: 'Expense codes',
  },
];
